namespace Matrix.Common {
    export interface UserPreferenceRetrieveRequest extends Serenity.ServiceRequest {
        PreferenceTypeCode?: string;
        PreferenceName?: string;
    }
}
